// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1JGJZ","subheader":"ReorderModal_subheader__3IBy6","listWrap":"ReorderModal_listWrap__3hy4u"};